export default {
  namespaced: true,
  service_orders: {
    charts: {
      select: "Selecciona la gráfica",
      bar: "Barras",
      pie: "Dona",
      total: "Total de órdenes",
      loading: "Cargando gráficas disponibles…",
      load_error: "No se pudieron cargar las gráficas.",
      retry: "Reintentar",
      unavailable: "No hay gráficas disponibles de órdenes de servicio para tu usuario.",
      date_hint: "El período corresponde a la fecha de atención; inicia en el mes actual. Usa los filtros de la gráfica para cambiarlo.",
    },
    title: "Ordenes de servicio",
    reference_number: "Numero de referencia",
    company: "Empresa",
    facility: "Instalacion",
    attention_date: "Fecha de atencion",
    date_filters: "Filtros de fecha",
    status:"Estado",
    status_change_date:"fecha de cambio de estado",
    delete_selection:"borrar selección",
    required_fields_to_filter_by_date:"Campos obligatorios para filtrar por fecha",
    pending:"Pendiente",
    in_review:"En revision",
    in_progress:"En proceso",
    finished:"Finalizado",
    canceled:"Cancelado",
    show_maintenance_form: 'Mostrar formulario de mantenimiento'
  },
};
